<template>
  <div>
    <Label
      v-if="label"
      class="block mb-2"
      v-bind="labelProps"
      v-on="labelListeners"
    >
      {{ label }}
      <Icon
        v-if="tippy"
        v-tippy="{interactive: true}"
        class="ml-2 cursor-pointer text-dull text-sm"
        :content="tippy"
        name="info-circle"
      />
    </Label>

    <Typography variant="caption" class="block mb-2">
      {{ helperText }}
    </Typography>

    <!-- this doesn't work with variant 'inline' for the <Input /> -->
    <template v-if="hasIconStart || hasIconEnd">
      <div :class="[$style.inputWithIconContainer, {'w-full': fullWidth}]">
        <span
          v-if="hasIconStart"
          :class="$style.iconContainer"
          @click="$emit('iconClick')"
          class="rounded-tl rounded-bl"
        >
          <slot name="icon" />
        </span>
        <Input
          :class="[
            {
              [$style.inputWithIconStart]: hasIconStart,
              [$style.inputWithIconEnd]: hasIconEnd,
            },
            {'w-full': fullWidth},
          ]"
          :fullwidth="fullWidth"
          v-bind="$attrs"
          v-on="$listeners"
          ref="input"
        />
        <span
          v-if="hasIconEnd"
          @click="$emit('iconClick')"
          :class="$style.iconContainer"
          class="rounded-tr rounded-br"
        >
          <slot name="iconEnd" />
        </span>
      </div>
    </template>

    <Input
      v-else
      v-bind="$attrs"
      v-on="$listeners"
      :fullWidth="fullWidth"
      ref="input"
    />

    <Typography
      v-if="errorText && !nativeError"
      variant="caption"
      class="block mt-2 text-danger"
    >
      {{ errorText }}
    </Typography>
  </div>
</template>

<script>
import Input from '../Input';
import Label from '../Label';
import Icon from '../Icon';

export default {
  inheritAttrs: false,

  name: 'InputField',

  components: {
    Input,
    Label,
    Icon,
  },

  props: {
    tippy: {type: [String, Boolean], default: false},
    focus: {type: Boolean, default: false},
    labelProps: {type: Object},
    labelListeners: {type: Object},
    label: {type: String},
    helperText: {type: String},
    errorText: {type: [String, Boolean]},
    fullWidth: {type: Boolean},
    nativeError: {type: Boolean, default: false},
  },
  watch: {
    errorText(value) {
      const errorValue = value ? value : '';
      this.$refs.input.$el.setCustomValidity(errorValue);
    },
  },
  computed: {
    hasIconStart() {
      return Boolean(this.$slots.icon);
    },
    hasIconEnd() {
      return Boolean(this.$slots.iconEnd);
    },
  },

  mounted() {
    if (this.focus) {
      this.$refs.input.$el.focus();
    }
  },
};
</script>

<style module>
.iconContainer {
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  min-width: 40px;

  @apply p-2
    border
    border-dull;
}

.inputWithIconContainer {
  display: inline-flex;
  align-items: stretch;
}

.inputWithIconStart {
  border-left: none !important;
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

.inputWithIconEnd {
  border-right: none !important;
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}
</style>
